(function(){

  'use strict';

  var filterTableActions = {
    bindings: {
      searchFilterFn: '&',
      closeFilterFn: '&',
      clearFilterFn: '&'
    },
    template: ['<div class="row">',
                '<button type="button" class="link-aux font-sm col-md-5" data-ng-class="{\'disabled\': ctrl.isAllDisabled}" data-ng-click="$ctrl.clearFilter();">limpar filtros</button>',
                '<div class="text-right pull-right col-md-7">',
                  '<button type="button" class="btn btn-secondary col-md-6" data-ng-click="$ctrl.closeFilter()">cancelar</button>',
                  '<button type="button" data-ng-class="{\'disabled\': ctrl.isAllDisabled}" class="btn btn-success m-left-xs display-inline-block col-md-6" data-ng-click="$ctrl.searchFilter()">filtrar</button>',
                '</div>',
              '</div>'].join(''),
    controller: 'FilterTableActionsCtrl'
  };

  angular
  .module('mandaeApp')
  .component('filterTableActions', filterTableActions);

}());